import {
  BANK_RECO_LEDGER_REPORT_REQUEST,
  BANK_RECO_LEDGER_REPORT_FAILURE,
  BANK_RECO_LEDGER_BY_PARTY_REPORT_FAILURE,
  SET_BANK_RECO_LEDGER_PARTIES,
  SET_BANK_RECO_LEDGER_BY_PARTY,
  BANK_RECO_LEDGER_BY_PARTY_REPORT_REQUEST,
  SET_BANK_RECO_LEDGER_BY_SCHEDULE,
  BANK_RECO_LEDGER_REPORT_SCHEDULE_REQUEST
} from "../types/bank-reco-ledger-report-types";

const initialState = {
  ledgerParties: [],
  trialBalScheduleParties: [],
  tradingAccount: {},
  profitLossAccount: {},
  balanceSheet: {},
  ledgerByParty: {},
  ledgerBySchedule: [],
  loading: false,
  error: null,
};

const ledgerReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_RECO_LEDGER_REPORT_REQUEST: {
      return {
        ...state,
        ledgerParties: [],
        trialBalScheduleParties: [],
        tradingAccount: {},
        profitLossAccount: {},
        balanceSheet: {},
        ledgerBySchedule: [],
        loading: true,
        error: null
      };
    }
    case BANK_RECO_LEDGER_REPORT_SCHEDULE_REQUEST: {
      return {
        ...state,
        ledgerBySchedule: [],
        loading: true,
        error: null
      };
    }
    case BANK_RECO_LEDGER_BY_PARTY_REPORT_REQUEST: {
      return {
        ...state,
        // ledgerByParty: {},
        loading: true,
        error: null
      };
    }
    case SET_BANK_RECO_LEDGER_PARTIES: {
        return {
          ...state,
          ledgerParties: action.payload || [],
          loading: false,
          error: null
        };
    }
    case SET_BANK_RECO_LEDGER_BY_PARTY: {
      return {
        ...state,
          ledgerByParty: action.payload || [],
          loading: false,
          error: null
      }
    }
    case SET_BANK_RECO_LEDGER_BY_SCHEDULE: {
      return {
        ...state,
          ledgerBySchedule: action.payload || [],
          loading: false,
          error: null
      }
    }
    case BANK_RECO_LEDGER_BY_PARTY_REPORT_FAILURE: {
      return {
        ...state,
        ledgerByParty: {},
        loading: false,
        error: action.error
      };
    }
    case BANK_RECO_LEDGER_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default ledgerReportReducer;
